import { Icons } from '@silverfort/sf-components';
import { useMemo } from 'react';
import { Application } from '../../../../types/Application';
import { ListItemProps } from '@silverfort/sf-components/dist/ListItem';

export const useRowMenuItems = (
    deleteApplicationLoading: boolean,
    userHasEditorRole: boolean,
    onDeleteApplicationClick: (value?: Application | null) => void,
    onEditApplicationClick: () => void
) => {
    return useMemo<Array<ListItemProps<Application>>>(() => {
        return [
            {
                IconLeft: Icons.Delete,
                disabled: !userHasEditorRole,
                onClick: onDeleteApplicationClick,
                title: 'Delete application'
            },
            {
                IconLeft: Icons.Edit,
                disabled: !userHasEditorRole || deleteApplicationLoading,
                onClick: onEditApplicationClick,
                title: 'Edit application'
            }
        ];
    }, [userHasEditorRole, onDeleteApplicationClick, deleteApplicationLoading, onEditApplicationClick]);
};
